/**
 * Day.js-Plugins vor allen anderen Modulen ausführen (früher wegen „Cannot access 'At' before initialization“
 * in Antd/rc-picker); Formate wie Quartal und Kalenderwoche brauchen die Erweiterungen.
 */
import dayjs from "dayjs";
import "dayjs/locale/de";
import "dayjs/locale/en";
import advancedFormat from "dayjs/plugin/advancedFormat";
import customParseFormat from "dayjs/plugin/customParseFormat";
import localeData from "dayjs/plugin/localeData";
import quarterOfYear from "dayjs/plugin/quarterOfYear";
import weekday from "dayjs/plugin/weekday";
import weekOfYear from "dayjs/plugin/weekOfYear";
import weekYear from "dayjs/plugin/weekYear";
import { LANGUAGE_DE, LANGUAGE_EN } from "../../../../shared/frontend/i18n/languageCodes";

dayjs.extend(customParseFormat);
dayjs.extend(advancedFormat);
dayjs.extend(weekday);
dayjs.extend(localeData);
dayjs.extend(quarterOfYear);
dayjs.extend(weekOfYear);
dayjs.extend(weekYear);

export function setDayjsLocaleForAppLanguage(language: string | null | undefined) {
  dayjs.locale(language === LANGUAGE_EN ? LANGUAGE_EN : LANGUAGE_DE);
}

setDayjsLocaleForAppLanguage("de");

